// extracted by mini-css-extract-plugin
export default {"tabletImg":"NK","desktopImg":"OK","mobileImg":"PK","backgroundImage":"QK","content":"RK","rtbLeft":"SK","rtbRight":"TK","imageContainer":"UK","rtbBox":"VK","line":"WK"};
    if(module.hot) {
      // 1714442370044
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  